<script setup lang="ts">
// Material Symbols `villa`, filled — the Properties nav glyph (matches investor-app tab bar). Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M3 21V8L16 3V12H17C17 11.45 17.1958 10.9792 17.5875 10.5875C17.9792 10.1958 18.45 10 19 10C19.55 10 20.0208 10.1958 20.4125 10.5875C20.8042 10.9792 21 11.45 21 12V21H3ZM5 19H9V12H14V5.9L5 9.375V19ZM11 19H14V16H16V19H19V14H11V19Z"
      fill="currentColor"
    />
  </svg>
</template>
